import { IServices } from "@netent/origin";
import { ICurrencyState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const currencyState: FeatureStateCreator<ICurrencyState> = (
  services: IServices
): ICurrencyState => services.money.getCurrencyFormat();
